import { TimeSheet } from "@components/modules/time-tracking/TimeSheet";
import { NavigationTime } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Time tracking`} navigation={<NavigationTime />}>
    <DemoModule module={Modules.TimeTracking}>
      <TimeSheet />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/time-tracking/day")({
  component: Page,
});
